import validate from "validate.js";


validate.validators.actionUrl = (value, options, key, attributes) => {
  const error = validate.single(attributes.action.url, {
    url: {
      message: 'is not a valid url (exampe: https://bestpush.io)'
    },
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  })

  if (attributes.action.value === 'open_link' && error) {
    return error;
  }

  return undefined;
}

validate.validators.buttons = (value, options, key, attributes) => {
  const buttons = attributes.buttons;

  const errors = buttons.map(button => {
    let error = {};

    error.text = validate.single(button.text, {
      presence: {
        allowEmpty: false,
        message: 'is required',
      },
    });

    if (button.action === 'open_link') {
      error.url = validate.single(button.url, {
        presence: {
          allowEmpty: false,
          message: 'is required',
        },
      });

      // This is to prevent showing multiple errors
      if (!error.url) {
        error.url = validate.single(button.url, {
          url: {
            message: 'is not a valid url (exampe: https://bestpush.io)'
          },
        });
      }
    }

    return error;
  });

  return [errors];
}


export default {
  title: {
    presence: {
      allowEmpty: false,
      message: "is required"
    },
  },
  content: {
    presence: {
      allowEmpty: false,
      message: "is required"
    }
  },
  'action.url': {
    actionUrl: {}, // use custom validate.validators.actionUrl
  },
  'buttons': {
    buttons: {}, // use custom validate.validators.buttons
  }
};